// client/src/components/ui/Icon.jsx
// Systeme d'icones unifie (SVG inline, inspaires de Lucide) — zero dependance.
import React from 'react';

const paths = {
  home: <><path d="M3 10.5 12 3l9 7.5" /><path d="M5 9.5V21h5v-6h4v6h5V9.5" /></>,
  play: <><circle cx="12" cy="12" r="9" /><path d="m10 8.5 5.5 3.5L10 15.5z" fill="currentColor" stroke="none" /></>,
  collection: <><rect x="3" y="7" width="14" height="14" rx="2" /><path d="M7 3h11a3 3 0 0 1 3 3v11" /></>,
  decks: <><rect x="4" y="4" width="12" height="16" rx="2" /><path d="M8 2h10a2 2 0 0 1 2 2v14" /><path d="M8 11h4M8 15h4" /></>,
  shop: <><path d="M6 7h12l1.5 13.5a1 1 0 0 1-1 1.5h-13a1 1 0 0 1-1-1.5L6 7z" /><path d="M9 10V6a3 3 0 0 1 6 0v4" /></>,
  rankings: <><path d="M8 21h8" /><path d="M12 17v4" /><path d="M7 4h10v6a5 5 0 0 1-10 0z" /><path d="M7 6H4v2a3 3 0 0 0 3 3" /><path d="M17 6h3v2a3 3 0 0 1-3 3" /></>,
  profile: <><circle cx="12" cy="8" r="4" /><path d="M4 21c1.5-4 5-6 8-6s6.5 2 8 6" /></>,
  news: <><path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-4 0V9" /><path d="M12 6h6M12 10h6M12 14h6M12 18h6" /></>,
  stats: <><path d="M3 3v18h18" /><rect x="7" y="12" width="3" height="6" /><rect x="12" y="8" width="3" height="10" /><rect x="17" y="5" width="3" height="13" /></>,
  status: <><path d="M22 12h-4l-3 9L9 3l-3 9H2" /></>,
  logout: <><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><path d="m16 17 5-5-5-5" /><path d="M21 12H9" /></>,
  login: <><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" /><path d="m10 17-5-5 5-5" /><path d="M3 12h12" /></>,
  sun: <><circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" /></>,
  moon: <><path d="M21 12.8A9 9 0 1 1 11.2 3 7 7 0 0 0 21 12.8z" /></>,
  close: <><path d="M18 6 6 18M6 6l12 12" /></>,
  music: <><path d="M9 18V5l12-2v13" /><circle cx="6" cy="18" r="3" /><circle cx="18" cy="16" r="3" /></>,
  cards: <><rect x="3" y="6" width="12" height="15" rx="2" /><path d="M8 3h9a2 2 0 0 1 2 2v12" /></>,
  sparkles: <><path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z" /><path d="M19 15l.9 2.4L22 18l-2.1.9L19 21l-.9-2.1L16 18l2.1-.6z" /></>,
  userplus: <><circle cx="10" cy="8" r="4" /><path d="M2 21c1.3-3.5 4.5-5 8-5s6.7 1.5 8 5" /><path d="M19 8v6M16 11h6" /></>,
  pause: <><rect x="7" y="5" width="3.5" height="14" rx="1" /><rect x="13.5" y="5" width="3.5" height="14" rx="1" /></>,
  wallet: <><path d="M20 7H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2z" /><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" /><path d="M2 12h20" /><circle cx="12" cy="15.5" r="1.4" fill="currentColor" stroke="none" /></>,
  coins: <><circle cx="9" cy="9" r="6" /><circle cx="15" cy="15" r="6" /><path d="M12 3.5A6 6 0 1 0 20.5 12 6 6 0 0 0 12 3.5z" /></>,
  // R60 — icônes de campagne (nœuds de la carte)
  swords: <><path d="M14.5 17.5 3 6V3h3l11.5 11.5" /><path d="m13 19 6-6" /><path d="m16 16 4 4" /><path d="m19 21 2-2" /><path d="M14.5 6.5 18 3h3v3l-3.5 4" /><path d="m5 14 4 4" /><path d="m7 17-3 3" /><path d="m3 19 2 2" /></>,
  crown: <><path d="m3 6 4 5 5-7 5 7 4-5-1.5 11h-15z" /><path d="M5 20h14" /></>,
  gem: <><path d="M7 3h10l4 6-9 12L3 9z" /><path d="M3 9h18" /><path d="m12 21-4-12M12 21l4-12" /></>,
  scroll: <><path d="M17 3H7a2 2 0 0 0-2 2v12" /><path d="M5 17a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5" /><path d="M5 17V5a2 2 0 0 1 2-2" /><path d="M9 8h5M9 12h5M9 16h3" /></>,
  flag: <><path d="M4 21V4" /><path d="M4 4c2.5-1.6 5-1.6 7.5 0S16 5.6 18.5 4L20 3.4V13l-1.5.6c-2.5 1.6-5 1.6-7.5 0S6.5 12.4 4 14" /></>,
  skull: <><path d="M12 2a8 8 0 0 0-8 8c0 2.6 1.2 4.7 3 6.1V19a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-2.9c1.8-1.4 3-3.5 3-6.1a8 8 0 0 0-8-8z" /><circle cx="9" cy="11" r="1.5" fill="currentColor" stroke="none" /><circle cx="15" cy="11" r="1.5" fill="currentColor" stroke="none" /><path d="M10.5 16.5h3" /></>,
  lock: <><rect x="5" y="11" width="14" height="9" rx="2" /><path d="M8 11V8a4 4 0 0 1 8 0v3" /><circle cx="12" cy="15.5" r="1.3" fill="currentColor" stroke="none" /></>,
  star: <><path d="m12 3 2.7 5.7 6.3.8-4.6 4.3 1.2 6.2L12 17l-5.6 3 1.2-6.2L3 9.5l6.3-.8z" /></>,
  chevronLeft: <><path d="m14 6-6 6 6 6" /></>,
};

const Icon = ({ name, size = 18, className = '', strokeWidth = 2 }) => {
  const content = paths[name];
  if (!content) return null;
  return (
    <svg
      className={`icon icon-${name} ${className}`.trim()}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {content}
    </svg>
  );
};

export default Icon;
